export default __webpack_public_path__ + "locales/en/Article.json?hash=e34a6d956fe21199c2db7e4f4636e283";